import { SVG_Heart_Linear } from '@dev-mobligo/iconpack';
import { ChildComponents } from '../../DnDChildComponents';

import { useSelector } from 'react-redux';

function Product_24({ customization, imgObj, productWidth, iconFilters }) {
  const imageHashMap = useSelector(state => state.themeSlice?.imageHashMap);
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const productDiscountPriceTextSize = customization?.productDiscountPriceTextSize?.replace('px', '');
  const productPriceTextSize = customization?.productPriceTextSize?.replace('px', '');

  return (
    <div style={{ padding: customization?.padding, width: productWidth + '%' }}>
      <div
        className="height-auto-info border-box-new  overflow-hidden bg-white h-full flex flex-col "
        style={{
          borderWidth: 1,
          borderColor: customization?.borderColor,
          borderRadius: customization?.borderRadius,
          padding: customization?.betweenProductAndBorderPadding,
          boxShadow: ChildComponents[customization?.boxShadow]?.data,
        }}
      >
        <div
          className="shrink-0"
          style={{
            height: customization?.productImageHeight,
            padding: customization?.productImagePadding,
            backgroundColor:
              customization?.productBackgroundType === 'productBackgroundColor'
                ? customization?.productBackgroundColor
                : '',
            backgroundImage:
              customization?.productBackgroundType === 'productBackgroundImage'
                ? `url(${customization?.productBackgroundImage})`
                : '',
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
            position: 'relative',
          }}
        >
          {imgObj?.image?.type === 'video' ? (
            <video
              style={{
                objectFit: customization?.backgroundSize,
                borderRadius: customization?.productImageBorderRadius,
              }}
              autoPlay
              muted
              playsInline
              loop
              src={imgObj?.image?.src}
            ></video>
          ) : (
            <img
              loading="lazy"
              src={imgObj?.useCustomImage ? imgObj?.image?.src : imageHashMap[imgObj?.id]?.image}
              className="widgets-ratio-1 h-full w-full"
              alt=""
              style={{
                objectFit: customization?.backgroundSize,
                borderRadius: customization?.productImageBorderRadius,
              }}
            />
          )}

          {customization?.isDiscountIcon && (
            <div
              className="absolute left-1 top-1 justify-center flex flex-row items-center"
              style={{
                zIndex: 30,
              }}
            >
              <div
                style={{
                  backgroundColor: customization?.discountIconBackgroundColor,
                  borderRadius: customization?.discountIconBorderRadius,
                  display: 'flex',
                  flexDirection: customization?.discountTextAlignment === 'row' ? 'row' : 'column',
                  padding: customization?.discountIconPadding,
                  gap: customization?.discountTextAlignment === 'row' ? 2 : 0,
                }}
              >
                <span
                  style={{
                    color: customization?.discountIconColor,
                    fontSize: customization?.discountIconWidth,
                    fontWeight: 500,
                  }}
                >
                  {'%100'}
                </span>
                <span
                  style={{
                    color: customization?.discountIconColor,
                    fontSize: customization?.discountIconWidth,
                    fontWeight: 500,
                  }}
                >
                  {customization?.discountText}
                </span>
              </div>
            </div>
          )}
          {customization?.isHeartIcon && (
            <div
              className=" 2xl:rounded-[10px] rounded-[7.97341324459px]   absolute right-1 top-1"
              style={{
                borderRadius: customization?.heartIconBorderRadius,
              }}
            >
              <img
                className="shrink-0"
                src={customization?.heartIcon}
                alt=""
                style={{ filter: iconFilters.heartIconFilter, width: customization?.heartIconWidth }}
              />
            </div>
          )}
        </div>
        <div
          className="flex flex-row  h-full"
          style={{
            backgroundColor: customization?.productDetailBackgroundColor,
          }}
        >
          <div
            className="w-full flex flex-col  py-[7%] pl-[4%] pr-[5%]"
            style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}
          >
            <div
              className="  shrink-1 flex items-start flex-col overflow-hidden "
              style={{ width: customization?.isCartIcon ? '75%' : '100%' }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                  gap: staticValues[10],
                  marginBottom: customization?.productTitleMarginBottom,
                }}
              >
                <div
                  className={`${
                    customization?.productTextControl === 'clip'
                      ? 'truncate'
                      : customization?.productTextControl === 'double'
                      ? 'line-clamp-2'
                      : 'line-clamp-3'
                  } w-full text-left`}
                  style={{
                    height: customization?.dynamicHeight
                      ? customization?.productTextControl === 'clip'
                        ? customization?.productTextSize?.replace('px', '') + 'px'
                        : customization?.productTextControl === 'double'
                        ? customization?.productTextSize?.replace('px', '') * 2 + 'px'
                        : customization?.productTextSize?.replace('px', '') * 3 + 'px'
                      : 'auto',
                    color: customization?.productTextColor,
                    fontSize: customization?.productTextSize,
                    lineHeight: customization?.productTextSize,
                    fontWeight: customization?.productTextWeight,
                    textAlign: customization?.productTextAlignment,
                    color: customization?.productTextColor,
                    fontSize: customization?.productTextSize,
                    lineHeight: customization?.productTextSize,
                    fontWeight: customization?.productTextWeight,
                    textAlign: customization?.productTextAlignment,
                  }}
                >
                  {imgObj?.image?.text}
                </div>
              </div>
            </div>
            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  flexDirection: customization?.productPriceTextAlign,
                  width: '100%',
                }}
                className="  shrink-0 mt-[7%]    "
              >
                <div
                  className={` mr-[3px] mt-auto 2xl:mr-[3.76250409702px]  line-through text-left`}
                  style={{
                    fontSize:
                      customization?.productPriceTextAlign === 'row'
                        ? productDiscountPriceTextSize > staticValues[9]
                          ? staticValues[9] + 'px'
                          : productDiscountPriceTextSize + 'px'
                        : productDiscountPriceTextSize + 'px',
                    color: customization?.productDiscountPriceColor,
                    fontWeight: customization?.productDiscountPriceWeight,
                    // lineHeight: customization?.productPriceTextSize?.replace('px', '') * 0.9 + 'px',
                  }}
                >
                  ₺1,000.00
                </div>
                <div
                  className="text-bold  text-left"
                  style={{
                    fontSize:
                      customization?.productPriceTextAlign === 'row'
                        ? productPriceTextSize > staticValues[9]
                          ? staticValues[9] + 'px'
                          : productPriceTextSize + 'px'
                        : productPriceTextSize + 'px',
                    color: customization?.productPriceColor,
                    fontWeight: customization?.productPriceWeight,
                    // lineHeight: customization?.productPriceTextSize?.replace('px', '') * 0.9 + 'px',
                  }}
                >
                  ₺1,000.00
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  borderRadius: '50px',

                  gap: '3px',
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Product_24;
